import { render, staticRenderFns } from "./OwnerConfig.vue?vue&type=template&id=b87a39ee&scoped=true"
import script from "./OwnerConfig.vue?vue&type=script&lang=js"
export * from "./OwnerConfig.vue?vue&type=script&lang=js"
import style0 from "./OwnerConfig.vue?vue&type=style&index=0&id=b87a39ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a39ee",
  null
  
)

export default component.exports